const steps = [
  {
    number: '01',
    icon: 'ri-phone-line',
    title: 'Free Phone Consultation',
    description: 'Begin with a complimentary 10-minute call with Dr. Leder. Share your health concerns, ask questions, and discover whether this approach is right for your needs. No obligation, no pressure.',
    duration: '10 minutes',
  },
  {
    number: '02',
    icon: 'ri-stethoscope-line',
    title: 'Extended Initial Visit',
    description: 'Your first in-office visit includes a thorough health history review, comprehensive physical exam, and an in-depth conversation about your lifestyle, nutrition, and environment. Dr. Leder listens — really listens.',
    duration: '60–90 minutes',
  },
  {
    number: '03',
    icon: 'ri-microscope-line',
    title: 'Advanced Functional Testing',
    description: 'Specialized labs go beyond standard blood work. Comprehensive hormone panels, heavy metal screening, food sensitivity testing, gut health markers, and nutritional assessments paint a complete picture of your biochemistry.',
    duration: '1–2 weeks',
  },
  {
    number: '04',
    icon: 'ri-file-list-3-line',
    title: 'Personalized Protocol Design',
    description: 'Dr. Leder integrates your history, exam findings, and lab results to create a fully individualized treatment plan. This includes targeted supplementation, dietary guidance, IV therapy if indicated, and lifestyle interventions.',
    duration: 'Tailored to you',
  },
  {
    number: '05',
    icon: 'ri-heart-pulse-line',
    title: 'Treatment & Ongoing Support',
    description: 'Treatment begins with regular follow-up visits to monitor progress, adjust protocols, and ensure you\'re moving steadily toward your health goals. Dr. Leder remains accessible and committed to your long-term wellness.',
    duration: 'Ongoing',
  },
];

export default function ProcessSection() {
  return (
    <section className="py-20 px-6 lg:px-12 bg-teal-950 text-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-teal-400 text-sm font-semibold tracking-widest uppercase mb-3">Your Patient Journey</p>
          <h2 className="font-heading text-4xl lg:text-5xl font-bold text-white mb-5">
            What to Expect, Step by Step
          </h2>
          <p className="text-teal-300 text-lg max-w-2xl mx-auto">
            A transparent process designed to give you clarity, confidence, and real results.
          </p>
        </div>

        <div className="relative">
          {/* Connector line - desktop only */}
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-teal-800 z-0" style={{ top: '2.5rem' }}></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 relative z-10">
            {steps.map((step, i) => (
              <div key={i} className="flex flex-col items-start lg:items-center text-left lg:text-center">
                <div className="w-14 h-14 flex items-center justify-center bg-teal-700 rounded-full mb-4 flex-shrink-0 border-4 border-teal-950">
                  <i className={`${step.icon} text-white text-xl`}></i>
                </div>
                <span className="font-heading text-teal-500 text-xs font-bold tracking-widest mb-2">{step.number}</span>
                <h3 className="font-heading text-base font-semibold text-white mb-2">{step.title}</h3>
                <p className="text-teal-300 text-xs leading-relaxed mb-3">{step.description}</p>
                <span className="inline-block bg-teal-800 text-teal-300 text-xs px-3 py-1 rounded-full">{step.duration}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
